import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {TagType} from 'nutshell-graphql-types';

import {CueCardStack} from '../../glossary/layout/cue-card-stack';
import {useGetCueCardsForLocation} from '../../glossary/layout/helpers';

import {TagsSidebarSection} from './tags-sidebar-section';

type Props = {
    activeTable: TagType;
    accountTagCount: number;
    accountTagsLoading: boolean;
    leadTagCount: number;
    leadTagsLoading: boolean;
    contactTagCount: number;
    contactTagsLoading: boolean;
    archivedTagCount: number;
    archivedTagsLoading: boolean;
};

export function TagsSetupSidebar(props: Props) {
    const cueCards = useGetCueCardsForLocation('/setup/tag', 'settings-sidebar');

    return (
        <StackLegacy spacing={16}>
            <TagsSidebarSection {...props} />
            {cueCards ? <CueCardStack cards={cueCards} /> : undefined}
        </StackLegacy>
    );
}
